import React, { useEffect, useRef, useState } from 'react'
import * as d3 from 'd3'
import * as ChartUtils from '../../../../utilties/chartUtilities'
import { isMobile } from '../../../../utilties/mobileDetector'
import { injectIntl } from 'react-intl';
import { compose } from 'recompose'
import history from '../../../../utilties/history'

const LineChart = ({ width, height, data, min, max, intl, canvasHeight, lowerBound, upperBound, benchmarcs }) => {
	const canvas = useRef(null)
	const [margin, setMargin] = useState({ top: 20, right: 80, bottom: 30, left: 30 })
	const [offset, setOffset] = useState({ top: 20 })
	const xMin = 80
	const xMax = 100
	const lastCompletedPoint = data.slice().reverse().find(({ completed }) => completed)

	useEffect(() => {
		if (canvas && canvas.current && data && min != null && max != null) {
			lineChart(data, min, max, width, height, lowerBound, upperBound, benchmarcs)
		}

	}, [])

	if (isMobile) {
		canvasHeight = 280;
	}
	width = 967 - margin.left - margin.right;
	height = 400 - margin.top - margin.bottom;
	if (isMobile) {
		width = window.screen.width - 32 - margin.left - margin.right;
		height = canvasHeight - margin.top - margin.bottom;
	}

	const showTooltip = (node, d, tooltip, color, svg, wrapper, benchmarcType, benchmarcValue, fromResults) => {

		const wrapperRect = wrapper.getBoundingClientRect();
		const triggerRect = node.getBoundingClientRect();
		const windowWidth = window.innerWidth;

		const scrollX = wrapper.scrollLeft || 0;
		const scrollY = wrapper.scrollTop || 0;

		const tooltipWidth = isMobile ? 180 : 200;
		const svgMargin = margin?.left || 0;

		let tooltipX = triggerRect.left - wrapperRect.left + scrollX + triggerRect.width / 2 - tooltipWidth / 2 + svgMargin / 2 + 5;

		if (isMobile) {
			tooltipX = triggerRect.left - wrapperRect.left + scrollX + triggerRect.width / 2 - tooltipWidth / 2 + svgMargin / 2 - 2;
		}

		if (tooltipX < svgMargin + scrollX) {
			tooltipX = svgMargin + scrollX;
		}
		else if (tooltipX + tooltipWidth / 2 + 62 > windowWidth) {
			tooltipX = windowWidth + scrollX - tooltipWidth - 32 + svgMargin / 2 + 5;
		}

		let tooltipY = triggerRect.top - wrapperRect.top - 10 + scrollY;

		console.log("tooltipX:", tooltipX);
		console.log("tooltipWidth:", tooltipWidth);
		console.log("scrollX:", scrollX);
		console.log("tooltipX + tooltipWidth + 62:", tooltipX + tooltipWidth + 62);
		

		tooltip
			.transition()
			.duration(200)
			.style('opacity', 1);
	
		const renderTooltipResult = renderTooltip(d, data, min, max, benchmarcType, benchmarcValue, fromResults);
	
		tooltip
			.html(renderTooltipResult.html)
			.style('position', 'absolute')
			.style('left', `${tooltipX}px`)
			.style('top', `${tooltipY}px`)
			.style('z-index', 9999)
			.style('pointer-events', 'none')
			.style('transform', 'translateY(-100%)'); 
		
		d3.select(node)
			.attr('fill', '#FFFFFF')
			.attr('stroke', color(node.parentNode.__data__.name))
			.attr('stroke-width', 4)
			.attr('r', 8.5);
	

		if (lastCompletedPoint && d.date !== lastCompletedPoint.xAxis) {
			svg.select('.x.axis .tick:nth-of-type(' + d.date + ') line').attr("color", "#000000")
		}

		svg.select('.x-top-info .tick:nth-of-type(' + d.date + ') .boxScoreLabel').attr("style", "background-color: #fff; color: #000;")
		svg.select('.x-top-info .tick:nth-of-type(' + d.date + ') .boxDueLabel').attr("style", "background-color: #9c0d2b; color: #fff; ")
	}

	const renderTooltip = (d, data, min, max, benchmarcType, benchmarcValue, fromResults) => {
		let point = data.find(({ xAxis }) => xAxis == d.date)
		let htmlResult = renderCohortInfo(point, benchmarcType, benchmarcValue, fromResults)

		return {
			html: htmlResult,
			cohortsCount: 1
		}
	}

	const showDueDateTooltip = (node, message, dueDateTooltip, wrapper) => {
		const wrapperRect = wrapper.getBoundingClientRect();
		const triggerRect = node.getBoundingClientRect();
		const tooltipWidth = isMobile ? 180 : 200;
	
		let tooltipX = triggerRect.left - wrapperRect.left + triggerRect.width / 2 - tooltipWidth / 2;
		let tooltipY = triggerRect.top - wrapperRect.top - 30

		dueDateTooltip
			.html(message)
			.style("position", "absolute")
			.style("left", `${tooltipX}px`)
			.style("top", `${tooltipY}px`)
			.style("opacity", 1)
			.style("background-color", "#e6f2ff")
			.style("color", "#777a7e")
			.style("font-weight", "500")
			.style("font-size", "12px")
			.style("padding", "8px 12px")
			.style("border-radius", "5px")
			.style("width", `${tooltipWidth}px`)
			.style("box-shadow", "0 0 5px rgba(0,0,0,0.1)");
	};

	const renderDueDateTooltip = (message) => {
		let htmlResult =
			`<div style='
				background-color: '#2d67d8'};
				padding: 11px 12px; font-size: 16px; color: white; text-align: left;
				'
			>
				${message}
			</div>`

		return {
			html: htmlResult,
			cohortsCount: 1
		}
	}

	const renderCohortInfo = (point, benchmarcType, benchmarcValue, fromResults) => {
		let scoreLabel = ChartUtils.getScoreLabel(point.myScore)
		let result = `
				<div style='
					background-color: #2d67d8;
					padding: 11px 12px; font-size: 16px; color: white; text-align: left;
					'
				>
					${intl.formatMessage({ id: 'app.chart.patientScoreLabel' })}
				</div>
				<div style='
					font-size: 16px; font-weight: bold;
					border: 3px solid #2d67d8;
					border-top: 0px;
					padding: 7px 12px 3px;
					color: black;'
				>
					<div style='
                content: "";
                clear: both;
                display: flex;'
            >
                <div style='float: left;'>
                    <div style='
                        padding: 5px 0px;
                        font-size: medium;'
                    >
                        ${scoreLabel}
                    </div>
                </div>
            </div>
				</div>
			`
		if (benchmarcValue || benchmarcValue === 0) {
			let benchmarcResult = `
				<div style='
					background-color: #5EA510;
					padding: 11px 12px; font-size: 16px; color: white; text-align: left;
					'
				>
					${intl.formatMessage({ id: 'app.chart.patientBenchmarcScoreLabel' })}
				</div>
				<div style='
					font-size: 16px; font-weight: bold;
					border: 3px solid #5EA510;
					border-top: 0px;
					padding: 7px 12px 3px;
					color: black;'
				>
					<div style='
				content: "";
				clear: both;
				display: flex;'
			>
				<div style='float: left;'>
					<div style='
						padding: 5px 0px;
						font-size: medium;'
					>
						${benchmarcType === 0 
							? ChartUtils.getScoreLabel(benchmarcValue) 
							: intl.formatMessage({ id: 'app.chart.patientBenchmarcScoreRangeLabel' }, {
								minValue: ChartUtils.getScoreLabel(benchmarcValue.minValue), 
								maxValue: ChartUtils.getScoreLabel(benchmarcValue.maxValue)
							})
						}
					</div>
				</div>
			</div>
				</div>
			`

			result = fromResults ? result + benchmarcResult : benchmarcResult + result
		}

		return result
	}

	const getBenchmarcValue = (benchmarcRates, date) => {
		return benchmarcRates && benchmarcRates[0] && benchmarcRates[0].values && benchmarcRates[0].values.find(v => v.date === date)?.responseRate
	}

	const drawBenchmarc = (benchmarcRates, benchmarcType, benchmarcColor, svg, tooltip, x, y) => {
		var benchmarcLine = d3
			.line()
			.x(function (d) {
				return x(d.date)
			})
			.y(function (d) {
				return y(d.responseRate)
			})
			.curve(d3.curveLinear)

		var benchmarcArea = d3
			.area()
			.x(function (d) {
				return x(d.date)
			})
			.y0(function (d) {
				return y(d.responseRate.minValue)
			})
			.y1(function (d) {
				return y(d.responseRate.maxValue)
			})
			.curve(d3.curveLinear)

		var benchmarcRate = svg.selectAll('.bRate').data(benchmarcRates).enter().append('g')

		benchmarcRate
			.append('path')
			.attr('class', 'bLine')
			.attr('transform', 'translate(40, 30)')
			.attr('d', function (d) {
				return benchmarcType === 0 ? benchmarcLine(d.values) : benchmarcArea(d.values)
			})
			.style('stroke', function (d) {
				return benchmarcColor(d.name)
			})
			.style('stroke-width', benchmarcType === 0 ? 3 : 1)
			.style('fill', benchmarcType === 0 ? 'none' : function (d) {
				return benchmarcColor(d.name)
			})
			.style('opacity', benchmarcType === 0 ? '1' : '0.3')
			.style('z-index', benchmarcType === 0 ? '0' : '-10')

		if (benchmarcType === 0) {
			benchmarcRate
				.selectAll('circle')
				.data(function (d) {
					return d.values
				})
				.enter()
				.append('circle')
				.attr('tabindex', '0')
				.attr('style', 'transition: all 0.25s ease')
				.attr('transform', 'translate(40, 30)')
				.attr('r', function (d, i, j) {
					return 7.1
				})
				.attr('fill', function (d, i, j) {
					return benchmarcColor(this.parentNode.__data__.name)
				})

				.attr('cx', function (d, i, j) {
					return x(d.date)
				})
				.attr('cy', function (d) {
					return y(d.responseRate)
				})
				.on('mouseover focus', function (d) {
					const wrapper = canvas.current.closest('.chart-wrapper')
					showTooltip(this, d, tooltip, benchmarcColor, svg, wrapper, benchmarcType, getBenchmarcValue(benchmarcRates, d.date), false)
				})
				.on('click', function (d) {
					if (!isMobile)
						return

					const wrapper = canvas.current.closest('.chart-wrapper');
					showTooltip(this, d, tooltip, benchmarcColor, svg, wrapper, benchmarcType, getBenchmarcValue(benchmarcRates, d.date), false)
				})
				.on('mouseout blur', function (d) {
					tooltip.transition().duration(500).style('opacity', 0)
					d3.select(this).attr('fill', benchmarcColor(this.parentNode.__data__.name))
					d3.select(this).attr('r', function (d, i, j) {
						return 7.1
					})
					d3.select(this).attr('stroke-width', function (d, i, j) {
						return 0
					})

					if (lastCompletedPoint && d.date !== lastCompletedPoint.xAxis) {
						svg.select('.x.axis .tick:nth-of-type(' + d.date + ') line').attr("color", "#e8e8e8")
					}

					svg.select('.x-top-info .tick:nth-of-type(' + d.date + ') .boxScoreLabel').attr("style", "background-color: #007AFF; color: #fff");
					svg.select('.x-top-info .tick:nth-of-type(' + d.date + ') .boxDueLabel').attr("style", "background-color: #1F2029; color: #fff");
				})
		}

		var totalLength = benchmarcRate.selectAll('path').node().getTotalLength();
		benchmarcRate.selectAll('path').attr("stroke-dasharray", totalLength)
			.attr("stroke-dashoffset", totalLength)
			.transition()
			.duration(2000)
			.attr('stroke-dashoffset', 0);
	}

	const lineChart = (data, min, max, width, height, lowerBound, upperBound, benchmarcs) => {
		var xTicks = data.length > 0 ? data.length : 0

		let xAxisTransform = 'translate(40, 380)';
		let tickFontSize = '16px';

		if (isMobile) {
			width = window.screen.width - 74 - margin.left - margin.right;
			height = canvasHeight - margin.top - margin.bottom;
			xAxisTransform = 'translate(40, 260)';
			tickFontSize = '10px';
			if (xTicks * 63 > width) {
				width = xTicks * 63;
			}
		}

		var x = d3.scaleLinear().range([0, width]).domain([xMin, xMax + (xMax - xMin) * .05])
		var y = d3.scaleLinear().range([height, 0]).domain([min, max + (max - min) * .05])

		const svg = d3.select(canvas.current).select('svg').attr('width', width + 100).attr('height', height).attr('style', 'margin-left: -80px')
		if (isMobile) {
			let svg = d3.select(canvas.current).select('svg').attr('width', width + 80).attr('height', height).attr('style', 'display: block; margin: 0 auto;')
		}

		var color = d3.scaleOrdinal().domain(['myScore']).range(['#2D67D8'])

		var xAxis = d3.axisBottom().scale(x)

		var yAxis = d3.axisRight().scale(y)

		var line = d3
			.line()
			.x(function (d) {
				return x(d.date)
			})
			.y(function (d) {
				return y(d.responseRate)
			})
			.curve(d3.curveLinear)

		// var labels = { myScore: 'My Results', allPatientsCircleScore: 'All Results' }

		function drawChart(data, benchmarcs) {
			var rates = color.domain().map(function (name) {
				return {
					name: name,
					values: data.filter(d => d.completed).map(function (d) {
						return {
							date: d.xAxis,
							responseRate: +d[name] || +d[name] === 0 ? +d[name] : 'undefined',
							completionDate: intl.formatDate(d.completionDate, { year: 'numeric', month: 'short', day: '2-digit' })
						}
					})
				}
			})

			let benchmarcColor = d3.scaleOrdinal().domain(['benchmarcScore']).range(['#5EA510'])
			let benchmarcType = benchmarcs && benchmarcs.type
			let benchmarcRates = benchmarcs && benchmarcs.benchmarcs
				? benchmarcColor.domain().map(function (name) {
					return {
						name: name,
						values: benchmarcs.benchmarcs
							.filter(d => (benchmarcType === 0 && d.singleValue !== null || benchmarcType === 1 && d.minValue !== null) && data.filter(y => y.completed).find(x => x.opsSurveyInstanceId === d.surveyInstanceId))
							.map(function (d) {
								return {
									date: data.find(x => x.opsSurveyInstanceId === d.surveyInstanceId).xAxis,
									responseRate: benchmarcType === 0 ? d.singleValue : { minValue: d.minValue, maxValue: d.maxValue },
								}
							}).sort((a, b) => a.date > b.date ? 1 : a.date < b.date ? -1 : 0)
					}
				})
				: null

			let xExtent = d3.extent(data, function (d) {
				return parseInt(d.xAxis)
			})

			let xRange = xExtent[1] - xExtent[0]

			x.domain([xExtent[0] - (xRange * .05), xExtent[1] + (xRange * .05)])
			svg.selectAll('*').remove()

			let tickValues = ChartUtils.spreadValues(min, max, 5)

			svg.select('.domain').style('color', '#11121C')

			svg
				.append('g')
				.attr('class', 'x-top-info')
				.attr('transform', 'translate(40, 20)')
				.style('stroke-opacity', '0')
				.call(d3.axisTop(x).tickValues(data.map(p => p.xAxis)).tickPadding(8).tickSize(0).tickSizeOuter(0).tickFormat(function (d) {
					return ''
				}))
				.selectAll("g")
				.append('svg:foreignObject')
				.attr('width', 70)
				.attr('height', 43)
				.attr('x', -35)
				.attr('y', -33)
				.attr('overflow', 'visible')
				.append('xhtml:div')
				.style('display', 'flex')
				.style('height', '100%')
				.style('color', '#666673')
				.style('border-radius', '5px')
				.html(function (d) { return ChartUtils.renderTopLabel(d, data, lowerBound, upperBound, intl) })
				.on('click', function (d) {
					let result = data.find(({ xAxis }) => xAxis == d)
					if (result.completed || result.upcoming)
						return

					let utc = (new Date()).getTime()
					const isOverdue = new Date(result.dueDate).getTime() < utc

					if ((!isOverdue || !result.isExpired) &&
						(result.isDue || isOverdue)) {
						const surveyLink = `/survey/${result.caseId}/${result.protocolId}/${result.opsSurveyInstanceId}/${result.opsSurveyId}`
						history.push(surveyLink);
					}
				})
				.on('mouseover focus touch', function (d) {

					let result = data.find(({ xAxis }) => xAxis == d);
					if (result.completed) return;

					const hoveredElement = d3.event.target.closest(".xTopLabelText");
					if (!hoveredElement) return;

					let utc = new Date().getTime();
					const isOverdue = new Date(result.dueDate).getTime() < utc;

					if ((isOverdue && result.isExpired) || (!result.isDue && !isOverdue && result.upcoming)) {
						let message = isOverdue && result.isExpired
							? intl.formatMessage({ id: "app.chart.isExpired" })
							: intl.formatMessage({ id: "app.chart.notDueYet" });

						const wrapper = canvas.current.closest('.chart-wrapper');
						showDueDateTooltip(this, message, dueDateTooltip, wrapper);

						const renderDueDateTooltipResult = renderDueDateTooltip(message);

						dueDateTooltip.html(renderDueDateTooltipResult.html)
					}

				})

				.on('mouseout blur', function (d) {
					dueDateTooltip.style('opacity', 0);
				})

			svg
				.append('g')
				.attr('class', 'x axis')
				.attr('color', '#11121C')
				.attr('transform', xAxisTransform)
				.call(
					xAxis.tickValues(data.map(p => p.xAxis)).tickPadding(8).tickSize(-height).tickSizeOuter(0).tickFormat(function (d) {
						let result = data.find(({ xAxis }) => xAxis === d)

						if (result.labelTreatmentPhaseId === 2) return result.labelValue + ChartUtils.getUnitLabel(result.labelUnit, intl)
						else return ChartUtils.getTreatmentLabel(result.labelTreatmentPhaseId, intl)
					})
				)
				.call(g => g.selectAll('.tick line')
					.attr('color', '#e8e8e8'))
				.call(g => g.selectAll('.tick text')
					.attr('stroke-width', '0.3')
					.attr('stroke-linejoin', 'round')
					.attr('stroke-linecap', 'round')
					.attr('dy', '1em')
					.attr('font-size', tickFontSize)
					.attr('font-weight', '600'))
				.call(g => {
					if (lastCompletedPoint) {
						g.selectAll('.tick:nth-of-type(' + lastCompletedPoint.xAxis + ') line').attr("stroke", "#000000")
					}
				})
				.append('text')
				.attr('fill', '#11121C')
				.attr('font-size', '16px')
				.attr('font-weight', 'bold')
				.attr('transform', 'translate(' + width / 2 + ', 60)')
				.text(intl.formatMessage({ id: 'app.chart.time' }))

			svg
				.append('g')
				.attr('class', 'y axis')
				.attr('transform', 'translate(' + (width + 40) + ', 30)')
				.call(
					yAxis.tickValues(tickValues).tickPadding(15).tickSize(-width).tickSizeOuter(0).tickFormat(function (d, i) {
						return i === 0 || i === tickValues.length - 1 ? d : ''
					})
				)
				.call(g => g.selectAll('.tick line')
					.attr('color', '#e8e8e8'))
				.call(g => g.selectAll(".tick:not(:first-of-type) line")
					.attr("stroke-opacity", 1)
					.attr("stroke-dasharray", "4"))
				.call(g => g.selectAll(".tick:first-of-type line")
					.attr("color", "#000"))
				.call(g => g.selectAll('.tick text')
					.attr('color', '#11121C')
					.attr('font-size', tickFontSize)
					.attr('font-weight', '600'))
				.append('text')
				.attr('transform', 'translate(' + (width + 40) + ',' + (height / 2) + ') rotate(-90)')
				.attr('fill', '#11121C')
				.attr('y', -30)
				.attr('x', height / 2 - 20)
				.attr('font-size', '16px')
				.attr('font-weight', 'bold')
				.text(intl.formatMessage({ id: 'app.chart.surveyScore' }))


			let tooltip = d3
				.select(`#${idGenerator}`)
				.append('div')
				.attr('id', 'tooltip')
				.style('opacity', 0)
				.style('position', 'absolute')
				.style('text-align', 'center')
				.style('font', '12px sans-serif')
				.style('background', '#fff')
				.style('border', '0px')
				.style('pointer-events', 'none')
				.style('z-index', '999')
				.style('-webkit-box-shadow', '8px 0px 18px 0px rgba(143,140,143,1)')
				.style('-moz-box-shadow', '8px 0px 18px 0px rgba(143,140,143,1)')
				.style('box-shadow', '8px 0px 18px 0px rgba(143,140,143,1)')

			let dueDateTooltip = d3
				.select(`#${idGenerator}`)
				.append('div')
				.attr('id', 'dueDateTooltip')
				.style('opacity', 0)
				.style('position', 'absolute')
				.style('text-align', 'center')
				.style('font', '12px sans-serif')
				.style('background', '#fff')
				.style('border', '0px')
				.style('pointer-events', 'none')
				.style('z-index', '999')
				.style('-webkit-box-shadow', '8px 0px 18px 0px rgba(143,140,143,1)')
				.style('-moz-box-shadow', '8px 0px 18px 0px rgba(143,140,143,1)')
				.style('box-shadow', '8px 0px 18px 0px rgba(143,140,143,1)')

			if (benchmarcs && benchmarcType === 1) {
				drawBenchmarc(benchmarcRates, benchmarcType, benchmarcColor, svg, tooltip, x, y)
			}

			var rate = svg.selectAll('.rate').data(rates).enter().append('g')

			rate
				.append('path')
				.attr('class', 'line')
				.attr('transform', 'translate(40, 30)')
				.attr('d', function (d) {
					return line(d.values)
				})
				.style('stroke', function (d) {
					return color(d.name)
				})
				.style('stroke-width', 3)
				.style('fill', 'none')

			rate
				.selectAll('circle')
				.data(function (d) {
					return d.values
				})
				.enter()
				.append('circle')
				.attr('tabindex', '0')
				.attr('style', 'transition: all 0.25s ease')
				.style('z-index', '100')
				.attr('transform', 'translate(40, 30)')
				.attr('r', function (d, i, j) {
					return d.date == lastCompletedPoint.xAxis ? 8.5 : 7.1
				})
				.attr('fill', function (d, i, j) {
					return d.date == lastCompletedPoint.xAxis ? '#FFFFFF' : color(this.parentNode.__data__.name)
				})
				.attr('stroke', function (d, i, j) {
					return d.date == lastCompletedPoint.xAxis ? '#2D67D8' : ''
				})
				.attr('stroke-width', function (d, i, j) {
					return d.date == lastCompletedPoint.xAxis ? 4 : ''
				})
				.attr('cx', function (d, i, j) {
					return x(d.date)
				})
				.attr('cy', function (d) {
					return y(d.responseRate)
				})
				.on('mouseover focus', function (d) {
					const wrapper = canvas.current.closest('.chart-wrapper')
					showTooltip(this, d, tooltip, color, svg, wrapper, benchmarcType, getBenchmarcValue(benchmarcRates, d.date), true)
				})
				.on('click', function (d) {
					if (!isMobile)
						return

					const wrapper = canvas.current.closest('.chart-wrapper');
					showTooltip(this, d, tooltip, color, svg, wrapper, benchmarcType, getBenchmarcValue(benchmarcRates, d.date), true)
				})
				.on('mouseout blur', function (d) {
					tooltip.transition().duration(500).style('opacity', 0)
					d3.select(this).attr('fill', d.date == lastCompletedPoint.xAxis ? '#FFFFFF' : color(this.parentNode.__data__.name))
					d3.select(this).attr('r', function (d, i, j) {
						return d.date == lastCompletedPoint.xAxis ? 8.5 : 7.1
					})
					d3.select(this).attr('stroke-width', function (d, i, j) {
						return d.date == lastCompletedPoint.xAxis ? 4 : 0
					})

					if (lastCompletedPoint && d.date !== lastCompletedPoint.xAxis) {
						svg.select('.x.axis .tick:nth-of-type(' + d.date + ') line').attr("color", "#e8e8e8")
					}
					svg.select('.x-top-info .tick:nth-of-type(' + d.date + ') .boxScoreLabel').attr("style", "background-color: #007AFF; color: #fff");
					svg.select('.x-top-info .tick:nth-of-type(' + d.date + ') .boxDueLabel').attr("style", "background-color: #1F2029; color: #fff");
				})

			if (rate.selectAll('circle').size() > 0) {
				rate
					.insert('circle', 'circle:last-child')
					.attr('transform', 'translate(40, 30)')
					.attr('class', 'circle-pulse')
					.attr('cx', function (d, i, j) {
						return this.parentNode.querySelector('circle:last-child').getAttribute("cx")
					})
					.attr('cy', function (d, i, j) {
						return this.parentNode.querySelector('circle:last-child').getAttribute("cy")
					})
					.attr('r', 35)
					.attr('fill', '#0067d8')

				// rate
				// 	.append('circle', 'circle:last-child')
				// 	.attr('transform', 'translate(40, 30)')
				// 	.attr('cx', function (d, i, j) {
				// 		return this.parentNode.getElementsByClassName('circle-pulse')[0].getAttribute("cx")
				// 	})
				// 	.attr('cy', function (d, i, j) {
				// 		return this.parentNode.getElementsByClassName('circle-pulse')[0].getAttribute("cy")
				// 	})
				// 	.attr('stroke', '#2D67D8')
				// 	.attr('fill', '#FFFFFF')
				// 	.attr('stroke-width', 4)
				// 	.attr('r', 8.5)
			}

			if (benchmarcs && benchmarcType === 0) {
				drawBenchmarc(benchmarcRates, benchmarcType, benchmarcColor, svg, tooltip, x, y)
			}

			// Animation
			var totalLength = rate.selectAll('path').node().getTotalLength();
			rate.selectAll('path').attr("stroke-dasharray", totalLength)
				.attr("stroke-dashoffset", totalLength)
				.transition()
				.duration(2000)
				.attr('stroke-dashoffset', 0);
		}

		drawChart(data, benchmarcs);

	}

	const idGenerator = 'chart_' + Math.random().toString(36).substr(2, 9);

	if (isMobile) {
		return (
			<div id='chartWrapper' className='chart-wrapper'>
				<div ref={canvas} id={idGenerator} className="patient-bar-chart" data-testid="bar-chart" style={{ width: width + margin.left + margin.right, height: canvasHeight ? canvasHeight : 320, margin: '60px auto 90px' }}>
					<svg />
				</div>
			</div>
		)
	} else {
		return (
			<div className='chart-wrapper'>
				<div ref={canvas} id={idGenerator} className="patient-bar-chart" data-testid="bar-chart" style={{ width: width, height: canvasHeight ? canvasHeight : 390, margin: '60px auto 90px' }}>
					<svg />
				</div>
			</div>
		)
	}
}


const enhance = compose(injectIntl)

export default enhance(LineChart)
